const TheUserMain = () => import('../views/TheUserMain.vue')
const UserTasks = () => import('../views/UserTasks.vue')
const TheUserRequests = () => import('../views/TheUserRequests.vue')
const TheUserSettings = () => import('../views/TheUserSettings.vue')
const TheUserResourcesAndUsage = () => import('../views/TheUserResourcesAndUsage.vue')
const MonitoringDashboard = () => import('../views/MonitoringDashboard.vue')
const UserPools = () => import('../views/UserPools.vue')
const UserPoolsCreateAccount = () => import('../views/UserPoolsCreateAccount.vue')
const UserPoolsCreateWallet = () => import('../views/UserPoolsCreateWallet.vue')
const UserSettingsProfile = () => import('../views/UserSettingsProfile.vue')
const UserSettingsSSHKeys = () => import('../views/UserSettingsSSHKeys.vue')
const UserSettingsSecrets = () => import('../views/UserSettingsSecrets.vue')
const UserSettingsEnvVars = () => import('../views/UserSettingsEnvVars.vue')
const UserSettingsTableAccess = () => import('../views/UserSettingsTableAccess.vue')
const UserSettingsDropboxSync = () => import('../views/UserSettingsDropboxSync.vue')
const UserSettingsApiAccess = () => import('../views/UserSettingsApiAccess.vue')
const UserSettingsNuvolos = () => import('../views/UserSettingsNuvolos.vue')
const LimitHistory = () => import('../views/LimitHistory')

const MonitoringOverview = () => import('../components/MonitoringOverview.vue')
const PlanUtilization = () => import('../components/PlanUtilization.vue')
const CreditUtilization = () => import('../components/CreditUtilization.vue')
const ResourcePoolInventory = () => import('../components/ResourcePoolInventory.vue')
const NodePools = () => import('../components/NodePoolsPage.vue')
const CloudAccountsPage = () => import('../components/CloudAccountsPage.vue')

export default [
    {
        path: '/user',
        name: 'user-main',
        components: {
            default: TheUserMain
        },
        children: [
            {
                path: 'user-tasks',
                name: 'user-tasks',
                components: {
                    default: UserTasks
                }
            },
            {
                path: 'user-requests',
                name: 'user-requests',
                components: {
                    default: TheUserRequests
                }
            },
            {
                path: 'resources',
                name: 'user-resources',
                components: {
                    default: TheUserResourcesAndUsage
                }
            },
            {
                path: 'pools',
                name: 'user-pools',
                component: UserPools
            },
            {
                path: 'pools/create-account',
                name: 'user-pools-create-account',
                component: UserPoolsCreateAccount
            },
            {
                path: 'pools/create-wallet',
                name: 'user-pools-create-wallet',
                component: UserPoolsCreateWallet
            },
            {
                path: 'reporting-dashboard',
                name: 'reporting-dashboard',
                component: MonitoringDashboard
            },
            {
                path: 'reporting-dashboard/rp/:rpid',
                name: 'reporting-dashboard-rp',
                component: MonitoringDashboard,
                children: [
                    {
                        path: 'overview',
                        name: 'reporting-rp-overview',
                        component: MonitoringOverview
                    },
                    {
                        path: 'plan-utilization/:startDate?/:endDate?',
                        name: 'reporting-rp-plan-utilization',
                        component: PlanUtilization
                    },
                    {
                        path: 'credit-utilization/:startDate?/:endDate?',
                        name: 'reporting-rp-credit-utilization',
                        component: CreditUtilization
                    },
                    {
                        path: 'inventory',
                        name: 'reporting-rp-inventory',
                        component: ResourcePoolInventory
                    },
                    {
                        path: 'node-pools',
                        name: 'reporting-rp-node-pools',
                        component: NodePools
                    },
                    {
                        path: 'cloud-accounts',
                        name: 'reporting-rp-cloud-accounts',
                        component: CloudAccountsPage
                    }
                ]
            },
            {
                path: 'reporting-dashboard/rp/:rpid/oid/:oid',
                name: 'reporting-dashboard-oid',
                component: MonitoringDashboard,
                children: [
                    {
                        path: 'overview',
                        name: 'reporting-oid-overview',
                        component: MonitoringOverview
                    },
                    {
                        path: 'plan-utilization/:startDate?/:endDate?',
                        name: 'reporting-oid-plan-utilization',
                        component: PlanUtilization
                    },
                    {
                        path: 'credit-utilization/:startDate?/:endDate?',
                        name: 'reporting-oid-credit-utilization',
                        component: CreditUtilization
                    },
                    {
                        path: 'inventory',
                        name: 'reporting-oid-inventory',
                        component: ResourcePoolInventory
                    },
                    {
                        path: 'node-pools',
                        name: 'reporting-oid-node-pools',
                        component: NodePools
                    },
                    {
                        path: 'cloud-accounts',
                        name: 'reporting-oid-cloud-accounts',
                        component: CloudAccountsPage
                    }
                ]
            },
            {
                path: 'reporting-dashboard/rp/:rpid/oid/:oid/sid/:sid',
                name: 'reporting-dashboard-sid',
                component: MonitoringDashboard,
                children: [
                    {
                        path: 'overview',
                        name: 'reporting-sid-overview',
                        component: MonitoringOverview
                    },
                    {
                        path: 'plan-utilization/:startDate?/:endDate?',
                        name: 'reporting-sid-plan-utilization',
                        component: PlanUtilization
                    },
                    {
                        path: 'credit-utilization/:startDate?/:endDate?',
                        name: 'reporting-sid-credit-utilization',
                        component: CreditUtilization
                    },
                    {
                        path: 'inventory',
                        name: 'reporting-sid-inventory',
                        component: ResourcePoolInventory
                    },
                    {
                        path: 'node-pools',
                        name: 'reporting-sid-node-pools',
                        component: NodePools
                    },
                    {
                        path: 'cloud-accounts',
                        name: 'reporting-sid-cloud-accounts',
                        component: CloudAccountsPage
                    }
                ]
            },
            {
                path: 'ncu-limit-history/:rpid',
                name: 'ncu-limit-history',
                component: LimitHistory,
                props: { limitType: 'ncu' }
            },
            {
                path: 'fs-limit-history/:rpid',
                name: 'fs-limit-history',
                component: LimitHistory,
                props: { limitType: 'fs' }
            },
            {
                path: 'resting-limit-history/:rpid',
                name: 'resting-limit-history',
                component: LimitHistory,
                props: { limitType: 'resting' }
            },
            {
                path: 'settings',
                name: 'user-settings',
                redirect: {
                    name: 'user-profile'
                },
                components: {
                    default: TheUserSettings
                },
                children: [
                    {
                        path: 'profile',
                        name: 'user-profile',
                        components: {
                            default: UserSettingsProfile
                        }
                    },
                    {
                        path: 'ssh',
                        name: 'user-ssh',
                        components: {
                            default: UserSettingsSSHKeys
                        }
                    },
                    {
                        path: 'secrets',
                        name: 'user-secrets',
                        components: {
                            default: UserSettingsSecrets
                        }
                    },
                    {
                        path: 'env-vars',
                        name: 'user-env-vars',
                        components: {
                            default: UserSettingsEnvVars
                        }
                    },
                    {
                        path: 'tables',
                        name: 'user-tables',
                        components: {
                            default: UserSettingsTableAccess
                        }
                    },
                    {
                        path: 'dropbox',
                        name: 'user-dropbox',
                        components: {
                            default: UserSettingsDropboxSync
                        }
                    },
                    {
                        path: 'api-access',
                        name: 'user-api-access',
                        components: {
                            default: UserSettingsApiAccess
                        }
                    },
                    {
                        path: 'nuvolos-settings',
                        name: 'user-nuvolos-settings',
                        components: {
                            default: UserSettingsNuvolos
                        }
                    }
                ]
            }
        ]
    }
]
